import recordWithOthers from './RecordWithOthers.png';

const RecordWithOthersIcon = () => {
    return <img src={recordWithOthers} alt="G icon" width="63px" height="46px" />;
};

export default RecordWithOthersIcon;